export default [
  {
    path: '/auth-info',
    name: 'auth-info',
    meta: { title: '实名认证', auth: true },
    component: () => import('../../views/user/auth-info.vue')
  },
  {
    path: '/my-auth',
    name: 'my-auth',
    meta: { title: '实名认证', auth: true },
    component: () => import('../../views/user/my-auth.vue')
  },
  {
    path: '/my-center',
    name: 'my-center',
    meta: { title: '个人中心', keepAlive: true, deepth: 1, auth: true },
    component: () => import('../../views/user/my-center.vue')
  },
  {
    path: '/my-info',
    name: 'my-info',
    meta: { title: '个人信息', auth: true },
    component: () => import('../../views/user/my-info.vue')
  },
  {
    path: '/my-area',
    name: 'my-area',
    meta: { title: '擅长区域', auth: true },
    component: () => import('../../views/user/my-area.vue')
  },
  {
    path: '/my-industry',
    name: 'my-industry',
    meta: { title: '擅长行业', auth: true },
    component: () => import('../../views/user/my-industry.vue')
  },
  {
    path: '/my-verify',
    name: 'my-verify',
    meta: { title: '我的认证', auth: true },
    component: () => import('../../views/user/my-verify.vue')
  },
  {
    path: '/about-me',
    name: 'about-me',
    meta: { title: '关于我们', auth: true, color: '#FD6404' },
    component: () => import('../../views/user/about-me.vue')
  }
];
